import { people01, people02, people03, facebook, instagram, linkedin, twitter, airbnb, binance, coinbase, dropbox, send, shield, star,gt1,gt2  } from "../assets";

export const navLinks = [
  {
    id: "",
    title: "Home",
  },
  {
    id: "case-studies",
    title: "Case Studies",
  },
  {
    id: "contact",
    title: "Contact Us",
  },
  
];

export const features = [
  {
    id: "feature-1",
    icon: gt1,
    title: "Tell us your Pain Points",
    content:
      "Our first step involves talking to you to understand and identify the pain-points which are pertinent to your business problems.",
  },
  {
    id: "feature-2",
    icon: gt2,
    title: "Sit back And Relax",
    content:
      "You can think of us as your extended team. We always ensure that we understand your problems and requirements extensively and translate them into a thorough action plan. We develop new systems & pipelines and derive insights & value out of data that solve your problems and put you ahead of your competition.",
  },
  // {
  //   id: "feature-3",
  //   icon: send,
  //   title: "Balance Transfer",
  //   content:
  //     "A balance transfer credit card can save you a lot of money in interest charges.",
  // },
];

export const feedback = [
  {
    id: "feedback-1",
    content:
      "Money is only a tool. It will take you wherever you wish, but it will not replace you as the driver.",
    name: "Herman Jensen",
    title: "Founder & Leader",
    img: people01,
  },
  {
    id: "feedback-2",
    content:
      "Money makes your life easier. If you're lucky to have it, you're lucky.",
    name: "Steve Mark",
    title: "Founder & Leader",
    img: people02,
  },
  {
    id: "feedback-3",
    content:
      "It is usually people in the money business, finance, and international trade that are really rich.",
    name: "Kenn Gallagher",
    title: "Founder & Leader",
    img: people03,
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "User Active",
    value: "3800+",
  },
  {
    id: "stats-2",
    title: "Trusted by Company",
    value: "230+",
  },
  {
    id: "stats-3",
    title: "Transaction",
    value: "$230M+",
  },
];

export const footerLinks = [
  {
    title: "Useful Links",
    links: [
      {
        name: "Home",
        link: "https://www.hoobank.com/content/",
      },
      {
        name: "Case Studies",
        link: "https://www.hoobank.com/how-it-works/",
      },
      {
        name: "Contact Us",
        link: "https://www.hoobank.com/create/",
      },

    ],
  },
  {
    title: "Contact Information",
    links: [
      {
        name: "Pinhead Analytics Private Limited, Diamond District, Old Airport Raod, Kodihalli, Bangalore - 560008.",
        link: "https://www.hoobank.com/help-center/",
      },
      {
        name: "contact@pinheadanalytics.com",
        link: "https://www.hoobank.com/partners/",
      },
      
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
  {
    id: "social-media-3",
    icon: twitter,
    link: "https://www.twitter.com/",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/",
  },
];

export const clients = [
  {
    id: "client-1",
    logo: airbnb,
  },
  {
    id: "client-2",
    logo: binance,
  },
  {
    id: "client-3",
    logo: coinbase,
  },
  {
    id: "client-4",
    logo: dropbox,
  },
];